import { useEffect, useRef } from 'react'

type AnimationDirection = 'forward' | 'backward'

/**
 * Tracks the navigation direction based on a changing index.
 * Returns 'forward' when the index increases, 'backward' when it decreases.
 * Defaults to 'forward' on the initial render and when the index is unchanged.
 */
export function useAnimationDirection(currentIndex: number): AnimationDirection {
  const previousIndexRef = useRef<number>(currentIndex)

  useEffect(() => {
    previousIndexRef.current = currentIndex
  }, [currentIndex])

  if (currentIndex < previousIndexRef.current) return 'backward'
  return 'forward'
}
